import axios from "../../../lib/axios";

export interface IBulkImportResult {
  updated: number;
  skipped: number;
  errors: { row: number; id: string; message: string }[];
  preview: { id: string; title: string; changes: string[] }[];
}

export const exportProductsCsv = async (): Promise<Blob> => {
  const res = await axios.get("/product/bulk/export", { responseType: "blob" });
  return res.data;
};

export const importProductsCsv = async (
  file: File,
  commit: boolean,
): Promise<IBulkImportResult> => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await axios.post(`/product/bulk/import?commit=${commit}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data.data;
};
